import { Injectable } from '@angular/core';
import {
  Firestore,
  addDoc,
  collection,
} from '@angular/fire/firestore';
import { addDays } from 'date-fns';
import { environment } from 'src/environments/environment';
import { FirebaseCollections } from '../consts/firebase.consts';
import { AppRoutePaths } from '../consts/routes.consts';

@Injectable({ providedIn: 'root' })
export class ExpirationBoundEntityRepository {
  constructor(
    private firestore: Firestore,
  ) {}
  public async earlyCheckInEmailUrl(processId?: string) {
    const entityData = {
      data: {
        processId,
        route: AppRoutePaths.EXTERNAL_DESK_CHECK_IN_RESERVATION_PREVIEW,
      },
      created: new Date(),
      expirationDate: addDays(new Date(), 7),
      id: processId,
    };
    const docRef = await addDoc(
      collection(this.firestore, FirebaseCollections.EXPIRATION_BOUND_ENTITY),
      entityData
    );
    const url = `${this.kioskBaseUrl}${AppRoutePaths.EXTERNAL_DESK_CHECK_IN_RESERVATION_PREVIEW}?processId=${processId}&token=${docRef?.id}`;
    return url;
  }

  public get kioskBaseUrl() {
    const res = environment.kioskBaseUrl; /// TODO - KIOSK URL
    return res;
  }
}
